import { AddProductToSavedBasketFromOrder } from "../../../Services/BasketService"
import { useAuth } from "../../../Providers/AuthProvider"
import { toast } from "react-toastify"
import { useConfig } from "../../../Providers/ConfigProvider"

const useAddProductsToSavedBasketFromOrder = () => {
    const { authState } = useAuth()

    const { api } = useConfig();

    const handleAddProductsToSavedBasketFromOrder = async (basketId, products) => {
        try {
            var res = await AddProductToSavedBasketFromOrder(api, basketId, products)
            toast.success('Dodano pozycje do szybkokoszyka')
            return true
        } catch (error) {
            toast.error('Błąd w trakcie dodawania pozycji do szybkokoszyka')
            return false
        }
    }

    return { handleAddProductsToSavedBasketFromOrder }
}

export default useAddProductsToSavedBasketFromOrder